import baseApi from './baseApi';

export const advisorsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all advisors
    getAdvisors: builder.query({
      query: () => '/advisors',
      providesTags: ['Advisors'],
    }),

    // Get single advisor by ID
    getAdvisor: builder.query({
      query: (advisorId) => `/advisors/${advisorId}`,
      providesTags: (result, error, advisorId) => [{ type: 'Advisors', id: advisorId }],
    }),

    // Advisor login
    loginAdvisor: builder.mutation({
      query: ({ username, password }) => ({
        url: '/advisors/login',
        method: 'POST',
        body: { username, password },
      }),
      transformResponse: (response) => {
        if (response?.token) {
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 1);
          document.cookie = `authToken=${response.token}; expires=${expirationDate.toUTCString()}; path=/`;
          localStorage.setItem("userID", response.advisor?.id);
        }
        return response;
      },
      invalidatesTags: ['Advisors'],
    }),

    // Advisor logout (client-side only) there is no endpoint in backend
    logoutAdvisor: builder.mutation({
      queryFn: async () => {
        try {
          // Clear authentication data
          localStorage.removeItem("userID");
          document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

          return { data: { success: true, message: "Logged out successfully" } };
        } catch (error) {
          return { error: { message: "Logout failed" } };
        }
      },
      invalidatesTags: ['Advisors'],
    }),
  }),
});

export const {
  useGetAdvisorsQuery,
  useGetAdvisorQuery,
  useLoginAdvisorMutation,
  useLogoutAdvisorMutation,
} = advisorsApi;

export default advisorsApi;
